import { selectors } from "store";

const creditSelectors = selectors.credit;

export default creditSelectors;
